<template>
  <div class="hello">
    <div class="search">
      <input type="text" class="inp" v-model="keyword" placeholder="输入道路、地标等关键字搜索" @change="search()">
    </div>
    <div class="bannerImg">
      <img src="../assets/banner3.png" alt="">
      <a href="tel:0551-68856050"></a>
    </div>
    
    <div class="sxCon" @click="screen=true">
      <img src="../assets/sx2.png" alt="">
    </div>
    <baidu-map :mapClick="false" @ready="mapReady" class="map-detail" :scroll-wheel-zoom="true" @dragend="changeCenter">
      <bm-marker  v-for="(item, index) of markers" :key="index"
        :icon="{ url: item.icon, size: { width: 50, height:58 } }"
        :position="{ lng: item.longitude, lat: item.latitude }" @click="lookDetail(item,index)" >
        <!-- <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation> -->
      </bm-marker>
    </baidu-map>
    <!-- 重定位 -->
    <img src="../assets/cdw.png" class="cdw" @click="onceMap()" alt="">
    <!-- marker详情弹窗 -->
    <div class="infoTip">
      <div class="infoTipCon" v-show="infoDetail">
        <img src="../assets/close.png" alt="" class="infoTip_close" @click="infoDetail=false">
        <div class="infoTip_tit">{{adInfo.name}}</div>
        <!-- <div class="infoTip_info">
          <div>资产编码:  <span style="background-color: #E7F0F6;padding: 1px 5px;">{{adInfo.number}}</span></div>
          <div :style="adInfo.state==0?'color: #56C556;':'color: #f00;'">{{adInfo.state==0?'空闲 可预约':'在用 不可预约'}}</div>
        </div> -->
        <div class="infoTip_list">
          <div class="infoTip_img">
            <img :src="adInfo.imgUrl" alt="">
          </div>
          <div class="infoTip_txt">
            <div class="infoTip_item" style="margin: .08rem auto .22rem;">
              <div class="color1">类型/数量：</div>
              <div class="color2">{{adInfo.typeName}}/{{adInfo.quantity}}个</div>
            </div>
            <div class="infoTip_item">
              <div class="color1">地址：</div>
              <div class="color2">{{adInfo.address}}</div>
            </div>
          </div>
        </div>
        <div class="infoTip_btn" @click="reservation=true">广告位预约咨询</div>
      </div>
    </div>
    <!-- 预约弹窗 -->
    <div class="maskBg" v-show="reservation" @click="reservation=false"></div>
    <div class="popTip" v-show="reservation">
      <div class="popTip_tit">广告投放预约</div>
      <div class="popTip_con">
          <div class="popTip_item">
            <div>姓&nbsp;&nbsp;&nbsp;名:<span>*</span></div>
            <input type="text" placeholder="请输入姓名" v-model="name" class="inp">
          </div>
          <div class="popTip_item">
            <div>联系方式:<span>*</span></div>
            <input type="number" placeholder="请输入联系方式" v-model="phone" class="inp">
          </div>
          <div class="popTip_item">
            <div>预约类型:<span>*</span></div>
            <div class="w35">
              <el-radio v-model="radio" label="1">个人</el-radio>
              <el-radio v-model="radio" label="2">企业</el-radio>
            </div>
          </div>
          <div class="popTip_item" style="align-items: normal;">
            <div>投放内容:</div>
            <textarea class="inp area" v-model="content" placeholder="请描述广告投放内容"></textarea>
          </div>
      </div>
      <div class="popTip_btn" @click="consultation(adInfo.id)">提交</div>
    </div>
    <!-- 筛选 -->
    <div class="maskBg2" v-show="screen" @click="screen=false"></div>
    <div class="screenTip" v-show="screen">
      <div class="screenTip_top">
        <img src="../assets/return.png" alt="" class="return" @click="screen=false">
        <input type="text" class="SearchInp" placeholder="输入道路、地标等关键字搜索" v-model="keyword" @change="search()">
      </div>
      <div class="screenTip_con">
        <div class="screenTip_con_tit">区域</div>
        <div class="screenTip_con_list">
            <div class="screenTip_item" :class="item.sel?'on':''" v-for="(item,index) in areaList" :key=""index @click="changeArea(item)">{{item.areaName}}</div>
        </div>
        
        <div class="screenTip_con_tit">广告位类型</div>
        <div class="screenTip_con_list third">
          <div class="screenTip_item" :class="item.sel?'on':''" v-for="(item,index) in areaTypeList" :key=""index @click="changeAreaType(item)">{{item.typeName}}</div>
        </div>
        
        <!-- <div class="screenTip_con_tit">广告类型</div>
        <div class="screenTip_con_list">
          <div class="screenTip_item" :class="item.sel?'on':''" v-for="(item,index) in adList" :key=""index @click="changeTwo(item)">{{item.name}}</div>
        </div> -->
        
        <div class="screenTip_con_tit">广告数量</div>
        <div class="screenTip_con_list third">
          <div class="screenTip_item" :class="item.sel?'on':''" v-for="(item,index) in numList" :key=""index @click="changeOne(item)">{{item.name}}</div>
        </div>
      </div>
      <div class="screenTip_btn">
        <div class="btn btn1" @click="reset()">重置</div>
        <div class="btn btn2" @click="screen=false">保存</div>
      </div>
    </div>
    <img src="../assets/banner2.png" class="banner2" alt="" v-show="!infoDetail">
  </div>
</template>

<script>
	import {List,infoDetail,AreaList,TypeList,Appointment} from '@/api/home'
  import {Message,MessageBox} from 'element-ui'
  export default {
    name: 'mapSearch',
    props: {
      typeId:{
        type:String,
        default:'',
      }
    },
    components: {},
    data() {
      return {
          map: null,
          markers: [],
          a:'117.218631',
          b:'31.800013',
          name:'',
          phone:'',
          content:'',
          reservation:false,
          screen:false,
          areaList:[],
          areaTypeList:[],
          adList:[{
            name:'车身广告',
            id:1,
            sel:false
          },{
            name:'政府宣传',
            id:2,
            sel:false
          },{
            name:'商业广告',
            id:3,
            sel:false
          },{
            name:'公益广告',
            id:4,
            sel:false
          },{
            name:'城市宣传',
            id:5,
            sel:false
          },{
            name:'其他',
            id:6,
            sel:false
          },],
          numList:[{
            name:'不限',
            id:-1,
            sel:false
          },{
            name:'1个',
            id:1,
            sel:false
          },{
            name:'2个',
            id:2,
            sel:false
          },{
            name:'20个以上',
            id:-2,
            sel:false
          },],
          infoDetail:false,
          keyword:'',
          type:[],
          num:-1,
          area:[],
          adInfo:[],
          startLat:'',//自身定位
          startLng:'',//自身定位
          moveLat:'',//移动后定位
          moveLng:'',//移动后定位
          loading:null,
          radio:'1'
      }
    },
    mounted(e) {
      // console.log(123)
      // console.log(this.typeId)
      if(this.typeId){
        this.type=[]
        // e.sel=!e.sel
        this.type.push(this.typeId)
        this.markers=[]
        // this.areaTypeList.forEach((element,index) => {
        //   if(element.typeId==this.typeId){
        //     element.sel=true
        //   }
        // });
      }
      // this.getList()
      this.getAreaList()
      this.TypeList()
      this.loading = this.$loading({ lock: true, text: '拼命加载中...', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'});
    },
    methods: {
      // 获取列表
      getList(){
        // console.log('请求接口')
        let that = this
        var param = {area:that.area,quantity:that.num,searchBody:that.keyword,type:that.type,latitude:that.moveLat,longitude:that.moveLng}
        List(param).then(res => {
        // console.log('返回接口')
          // that.markers = res.data
          for(let i in res.data){
            // if(res.data[i].type  =="公交站台灯箱广告"){
            //   res.data[i].icon ='http://ad.iyoutui.cn/img/icon01.png';
            // }else if(res.data[i].shopStatus  ==1){
            //   res.data[i].icon ='http://ad.iyoutui.cn/img/icon02.png';
            // }else{
            //   res.data[i].icon ='http://ad.iyoutui.cn/img/icon03.png';
            // }
            if(i%3 == 1){
              res.data[i].icon ='https://ad.iyoutui.cn/img/icon01.png';
            }else if(i%3 == 2){
              res.data[i].icon ='https://ad.iyoutui.cn/img/icon02.png';
            }else{
              res.data[i].icon ='https://ad.iyoutui.cn/img/icon03.png';
            }
            res.data[i].latitude =that.bd_encrypt(res.data[i].longitude,res.data[i].latitude).bd_lat;
            res.data[i].longitude =that.bd_encrypt(res.data[i].longitude,res.data[i].latitude).bd_lng;
            res.data[i].shopName =res.data[i].name;
            that.markers.push(res.data[i]);
            if(that.startLng=='' || that.startLat==''){
              that.startLng = res.data[0].longitude
              that.startLat = res.data[0].latitude
              that.moveLng = res.data[0].longitude
              that.moveLat = res.data[0].latitude
            }
            // 筛选或搜索选中第一项
            if(res.data.length>0){
              if(that.area.length>0 || that.num != -1 || that.keyword!='' || that.type>0){
                that.moveLng = res.data[0].longitude
                that.moveLat = res.data[0].latitude
              }
            }
            
          }
          let pointLat = that.bd_encrypt(that.moveLng,that.moveLat).bd_lat
          let pointLng = that.bd_encrypt(that.moveLng,that.moveLat).bd_lng
          let point = new BMap.Point(pointLng,pointLat);
          that.map.centerAndZoom(point, 15);
          // console.log('处理完毕！')
          that.loading.close();
        }).catch(err=>{
          console.log(err)
        })
      },
      // 重定位
      onceMap(){
        let that = this
        var point = new BMap.Point(that.startLng,that.startLat);
        that.map.centerAndZoom(point, 15);
      },
      // 移动定图
      changeCenter(e){
        // console.log(e.target.getCenter().lat)
        // this.map = {
        //         lng: e.target.getCenter()['lng'],
        //         lat: e.target.getCenter()['lat'],
        //         zoom: e.target.getZoom(),
        //     };
        // console.log(123)
        this.loading = this.$loading({ lock: true, text: '拼命加载中...', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'});
        this.moveLat = e.target.getCenter().lat
        this.moveLng = e.target.getCenter().lng
        this.getList()
      },
      // 获取区域
      getDetail(id){
        let that = this
        let param = {id:id}
        infoDetail(param).then(res => {
          that.adInfo = res.data
        })
      },
      // 获取区域
      getAreaList(){
        let that = this
        AreaList({pageSize:1000}).then(res => {
          res.data.list.forEach(event=>{
            // var it ={name:event.areaName,sel:false}
            event.sel=false
            that.areaList.push(event)
          })
        })
      },
      // 获取广告位的类别信息
      TypeList(){
        let that = this
        TypeList({pageSize:1000}).then(res => {
          // that.areaTypeList = res.data.list
          res.data.list.forEach(event=>{
            // var it ={name:event.typeName,sel:false}
            event.sel = false
            if(that.typeId && that.typeId==event.typeId){
              event.sel = true
            }
            that.areaTypeList.push(event)
          })
        })
      },
      // 预约咨询
      consultation(id){
        let that = this
        // console.log(this.radio)
        if(that.name==''){
          that.$message({
            message: '请输入姓名',
            type: 'error'
          });
          return
        }
        if(that.phone==''){
          that.$message({
            message: '请输入联系方式',
            type: 'error'
          });
          return
        }
        // var reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        // console.log(reg.test(that.phone))
        // if(!reg.test(that.phone)){
        //   that.$message({
        //     message: '请输入正确的联系方式',
        //     type: 'error'
        //   });
        //   return;
        // }
        let param={advId:id,content:that.content,linkman:that.name,linkphone:that.phone,linktype:that.radio}
        console.log(param)
        Appointment(param).then(res => {
          that.$message({
            message: '提交成功！',
            type: 'success'
          });
          that.reservation=false
          that.infoDetail=false
        })
      },
      // 初始化地图
      mapReady({BMap,map}) {
        // 选择一个经纬度作为中心点
        this.point = new BMap.Point(this.a,this.b);
        map.centerAndZoom(this.point, 9);
        this.map = map

        // console.log(localStorage.getItem('location'))
        // if(localStorage.getItem('location')){
        //   var locationInfo =  localStorage.getItem('locationInfo')
        //   this.startLat = locationInfo.latitude
        //   this.startLng = locationInfo.longitude
        //   this.moveLat = locationInfo.latitude
        //   this.moveLng = locationInfo.longitude
        //   this.getList()
        // }else{
        //   this.getList()
        // }

        let geolocation = new BMap.Geolocation()
        geolocation.enableSDKLocation(); //允许SDK辅助
        geolocation.getCurrentPosition(e=>{
          console.log(e)
          if(e.latitude && e.longitude){
            this.startLat = e.latitude
            this.startLng = e.longitude
            this.moveLat = e.latitude
            this.moveLng = e.longitude
            this.getList()
          }else{
            this.getList()
          }
          // if(geolocation.getStatus()=='BMAP_STATUS_SUCCESS'){
          //   this.startLat = e.latitude
          //   this.startLng = e.longitude
          //   this.moveLat = e.latitude
          //   this.moveLng = e.longitude
          //   this.getList()
          // }else{
          //   this.getList()
          // }
        })
      },
      
      //高德地图经纬度转百度经纬度
      bd_encrypt(gg_lng, gg_lat) {		  
        // var X_PI = Math.PI * 3000.0 / 180.0;
        // var x = gg_lng, y = gg_lat;
        // var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI);
        // var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * X_PI);
        // var bd_lng = z * Math.cos(theta) + 0.0065;
        // var bd_lat = z * Math.sin(theta) + 0.006;
        // return {
        //   bd_lat: bd_lat,
        //   bd_lng: bd_lng
        // };
        return {
          bd_lat: gg_lat,
          bd_lng: gg_lng
        };
      },
      // 点击查看marker弹窗详情
      lookDetail(marker, index) {
        this.infoDetail = true
        this.getDetail(marker.id)
      },
      closeInfoTip(marker, index) {
        // this.markers[index].show = false
      },
      // 筛选切换
      changeArea(e){
        // this.areaList.forEach((element,index) => {
        //   element.sel=false
        // });
        this.area=[]
        e.sel=!e.sel
        this.markers=[]
        this.areaList.forEach((element,index) => {
          if(element.sel){
            this.area.push(element.areaId)
          }
        });
        
        // console.log(this.area)
        this.getList()
      },
      changeAreaType(e){
        // this.areaTypeList.forEach((element,index) => {
        //   element.sel=false
        // });
        this.type=[]
        e.sel=!e.sel
        this.markers=[]
        this.areaTypeList.forEach((element,index) => {
          if(element.sel){
            this.type.push(element.typeId)
          }
        });
        this.getList()
      },
      // 数量切换
      changeOne(e){
        this.numList.forEach((element,index) => {
          element.sel=false
        });
        e.sel=true
        this.markers=[]
        this.num = e.id
        this.getList()
      },
      reset(){
        this.areaList.forEach(element => {element.sel=false})
        this.areaTypeList.forEach(element => {element.sel=false})
        this.adList.forEach(element => {element.sel=false})
        this.numList.forEach(element => {element.sel=false})
        this.num = -1
        this.area=[]
        this.type=[]
        this.keyword=''
        this.markers=[]
        this.getList()
      },
      // 搜索
      search(){
        // console.log(this.keyword)
        this.markers=[]
        this.getList()
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .cdw{
    position: fixed;
    bottom: 2.24rem;
    left: 0.32rem;
    z-index: 100;
    background: #fff;
    padding: 0.1rem;
    border-radius: 0.1rem;
    width: 0.7rem;
  }
  .search{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    z-index: 100;
    padding: .2rem .55rem;
  }
  .search .inp{
    /* position: fixed;
    top: .24rem;
    left: .32rem; */
    width: 6.4rem;
    height: 0.7rem;
    box-shadow: 0rem 0.04rem 0.2rem 0.02rem rgba(0,0,0,0.1);
    border-radius: 0.35rem 0.35rem 0.35rem 0.35rem;
    font-size: 0.26rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #333333;
    background: url(../assets/search.png) no-repeat .34rem center,#fff;
    background-size: 0.32rem;
    padding-left: .86rem;
    outline: none;
    border: none;
    display: block;
    box-sizing: border-box;
    box-shadow: 0rem 0.04rem 0.2rem 0.02rem rgba(0,0,0,0.1);
    text-align: center;
  }
  .bannerImg{
    position: fixed;
    top: 1.26rem;
    /* left: 50%; */
    left: .4rem;
    /* transform: translateX(-50%); */
    width: 5.72rem;
    z-index: 100;
  }
  .bannerImg img{
    width: 100%;
    height: 1.46rem;
  }
  .bannerImg a{
    position: absolute;
    top: 0;
    right: 0;
    display: block;
    height: 1.46rem;
    width: 3rem;
  }
  .banner2{
    position: fixed;
    bottom: 0rem;
    left: 50%;
    transform: translateX(-50%);
    width: 7.5rem;
    z-index: 99;
  }
  .sxCon{
    position: fixed;
    top: 1.7rem;
    right: .26rem;
    width: 0.72rem;
    height: 0.72rem;
    /* background: #149DFC; */
    background: #fff;
    box-shadow: 0rem 0.06rem 0.2rem 0.02rem rgba(0,0,0,0.1);
    border-radius: .13rem;
    z-index: 100;
  }
  .sxCon img{
    width: 0.4rem;
    height: 0.4rem;
    display: block;
    margin: .16rem auto 0;
  }
  .map-detail {
		width: 100%;
		height: 100vh;
		position: fixed;
		z-index: 99;
		top: 0px;
	}
  .infoTip{
    width: 6.9rem;
    background: #FFFFFF;
    box-shadow: 0rem 0rem 0.4rem 0.02rem rgba(0,0,0,0.1);
    border-radius: 0.24rem;
    border: 0.02rem solid #F7F7F7;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: .24rem;
    z-index: 100;
    box-sizing: border-box;
  }
  .infoTipCon{
    padding: .34rem .3rem;
  }
  .infoTip_close{
    position: absolute;
    top: .42rem;
    right: .46rem;
    width: 0.36rem;
    height: 0.36rem;
  }
  .infoTip_tit{
    font-size: 0.36rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #111111;
    text-align: center;
  }
  .infoTip_info{
    margin: .32rem auto 0;
    display: flex;
    justify-content: space-between;
    font-size: 0.24rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #111111;
  }
  .infoTip_list{
    margin: .46rem auto;
    display: flex;
    justify-content: space-between;
  }
  .infoTip_list .infoTip_img{
    width: 1.2rem;
    height: 1.2rem;
    overflow: hidden;
  }
  .infoTip_list .infoTip_img img{
    width: 1.2rem;
    height: 1.2rem;
    border-radius: .2rem;
  }
  .infoTip_list .infoTip_txt{
    width: 4.9rem;
  }
  .infoTip_list .infoTip_item{
    font-size: 0.28rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    display: flex;
    /* justify-content: space-between; */
  }
  .infoTip_list .color1{
    color: #666666;
  }
  .infoTip_list .color2{
    max-width: 3.2rem;
    color: #333333;
    /* text-align: right; */
  }
  .infoTip_btn{
    width: 6.3rem;
    line-height: 0.88rem;
    background: linear-gradient(264deg, #559BFD 0%, #1172FE 100%);
    border-radius: 0.16rem;
    text-align: center;
    font-size: 0.32rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
  }
  .maskBg,.maskBg2{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    background-color: rgba(0, 0, 0, .5);
  }
  .popTip{
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 6.1rem;
    /* height: 6.4rem; */
    background: #FFFFFF;
    box-shadow: 0rem 0rem 0.4rem 0.02rem rgba(0,0,0,0.16);
    border-radius: 0.24rem;
    border: 0.02rem solid #F7F7F7;
    z-index: 101;
    padding: .4rem .4rem .52rem;
    box-sizing: border-box;
  }
  .popTip_tit{
    font-size: 0.36rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #111111;
    line-height: 0.28rem;
    text-align: center;
  }
  .popTip_con{
    margin: .6rem auto .2rem;
  }
  input::placeholder,textarea::placeholder{color: #999;}
  .popTip_item{
    margin-bottom: .34rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .popTip_item div{
    font-size: 0.28rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 0.28rem;
  }
  .popTip_item div span{color: #f00;vertical-align: top;margin-left: 5px;}
  .popTip_item .inp{
    width: 3.7rem;
    height: .48rem;
    background: #FFFFFF;
    border-radius: 0.04rem 0.04rem 0.04rem 0.04rem;
    opacity: 1;
    border: none;
    /* text-align: left; */
    outline: none;
    box-sizing: border-box;
    font-size: 0.3rem;
    font-family: PingFang SC, PingFang SC;
    /* font-weight: bold; */
    color: #333333;
    /* background: url(../assets/edit.png) no-repeat right center; */
    background-size: 0.23rem;
    padding: 0 .4rem 0 .2rem;
    border-bottom: 0.02rem solid #D9D9D9;
  }
  .popTip_item .area{
    text-align: left;
    background: none;
    height: 1.42rem;
    border: 0.02rem solid #D9D9D9;
  }
  .popTip_item .w35{
    width: 3.7rem;
  }
  .popTip_btn{
    width: 100%;
    line-height: 0.88rem;
    background: linear-gradient(264deg, #5ECDF7 0%, #4EA1F7 100%);
    font-size: 0.32rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
    border-radius: .2rem;
  }
  .screenTip{
    position: fixed;
    top: 0;
    left: 0;
    max-height: 90vh;
    width: 100%;
    z-index: 102;
    background-color: #fff;
    padding: 0 .32rem .26rem;
    box-sizing: border-box;
  }
  .screenTip_top{
    padding: .3rem 0;
    display: flex;
    align-items: center;
  }
  .screenTip_top .return{
    width: .5rem;
    height: .5rem;
    margin-top: .05rem;
    display: block;
  }
  .screenTip_top .SearchInp{
    width: 6.6rem;
    height: 0.7rem;
    background: #FFFFFF;
    box-shadow: 0rem 0.04rem 0.2rem 0.02rem rgba(0,0,0,0.1);
    border-radius: 0.35rem;
    font-size: 0.26rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #333333;
    border: none;
    outline: none;
    background: url(../assets/search.png) no-repeat .34rem center;
    background-size: 0.32rem;
    padding: 0 .1rem 0 .86rem;
    box-sizing: border-box;
    display: block;
  }
  .screenTip_con{
    margin: .26rem auto .9rem;
    max-height: 8rem;
    overflow-y: scroll;
  }
  .screenTip_con .screenTip_con_tit{
    font-size: 0.28rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #111111;
    margin: .16rem auto;
  }
  .screenTip_con .screenTip_con_list{
    display: flex;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    /* justify-content: space-between; */
  }
  .screenTip_con .screenTip_item{
    min-width: 1.6rem;
    padding: 0 .3rem;
    line-height: 0.64rem;
    text-align: center;
    background: #F4F4F4;
    border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
    font-size: 0.24rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #111111;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: .24rem;
    box-sizing: border-box;
    margin-right: .15rem;
  }
  /* .screenTip_con .screenTip_item:nth-child(4n){margin-right: 0;} */
  .screenTip_con .screenTip_item.third:nth-child(3n){margin-right: 0;}
  .screenTip_con .screenTip_item.on{
    background-color: #DEF2FF;
    color: #149DFC;
  }
  .screenTip_btn{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 .12rem;
    box-sizing: border-box;
  }
  .screenTip_btn .btn{
    width: 3.2rem;
    line-height: 0.88rem;
    background: #FFFFFF;
    border-radius: 0.16rem 0.16rem 0.16rem 0.16rem;
    opacity: 1;
    border: 0.01rem solid #149DFC;
    box-sizing: border-box;
    font-size: 0.32rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #149DFC;
    text-align: center;
  }
  .screenTip_btn .btn2{
    border: none;
    background: linear-gradient(270deg, #5ECDF7 0%, #4EA1F7 100%);
    color: #FFFFFF;
  }

</style>
